module.exports = __webpack_public_path__ + "static/media/roundedshoulder_mild_right.83867ba4.png";